module.exports = __webpack_public_path__ + "527e3edbafce4bffed37a8f79f537cb7.MP3";